
const initialState = {
  data:[],
  loading:false,
  saving:false,
  error:null,

  fullById: { },// [id]: { data, loading, saving, error }

  selectedId: null,
  deletingId: null,
  publishingId: null,

  themes:{ data:[], loading:false, error:null},
  categories:{ data:[], loading:false, error:null},
};
    
const matrixReducer = (state = initialState, action) => {
  
  switch (action.type) {
    case 'LOAD_MATRICES_REQUEST':
      return { ...state, loading: true, error: null};
    case 'LOAD_MATRICES_SUCCESS':
      return { ...state, loading: false, data: action.payload, error: null};
    case 'LOAD_MATRICES_FAIL':
      return { ...state, loading: false, error: action.payload };
    
    case 'LOAD_MATRIX_FULL_REQUEST':{
      const id = action.payload;
      return {
        ...state,
        fullById: {
          ...state.fullById,
          [id]: { ...(state.fullById[id] || {}), loading: true, error: null },
        },
      };
    }
    case 'LOAD_MATRIXS_FULL_SUCCESS':{
      const full = action.payload;
      const id = full.Id;
      return {
        ...state,
        selectedId: id,
        fullById: {
          ...state.fullById,
          [id]: { data: full, loading: false, saving: false, error: null },
        },
      };
    }
    case 'LOAD_MATRIXS_FULL_FAIL':{
      const { id, error } = action.payload;
      return {
        ...state,
        fullById: {
          ...state.fullById,
          [id]: { ...(state.fullById[id] || {}), loading: false, error },
        },
      };
    }
    
    case 'SAVE_MATRIX_REQUEST':
      return { ...state, saving: true, error: null };
    case 'SAVE_MATRIX_SUCCESS':
      return { ...state, saving: false, selectedId: null};
    case 'SAVE_MATRIX_FAIL':
      return { ...state, saving: false, error: action.payload };

    case 'DELETE_MATRIX_REQUEST': 
      return {...state, deletingId: action.payload, error: null,};
    case 'DELETE_MATRIX_SUCCESS': {
      const nextData = (state.data || []).filter(m => m.Id !== action.payload);
      const { [action.payload]: _removed, ...restFull } = state.fullById;

      const nextSelected = state.selectedId === action.payload ? null : state.selectedId;

      return { ...state, deletingId: null, selectedId: nextSelected, data: nextData, fullById: restFull, };
    }
    case 'DELETE_MATRIX_FAIL':
      return { ...state, deletingId: null, error: action.payload || 'Error al eliminar la matriz',};
    
    case 'LOAD_THEMES_REQUEST':
      return { ...state, themes: { ...state.themes, loading: true, error: null },};
    case 'LOAD_THEMES_SUCCESS':
      return { ...state, themes: { ...state.themes, loading: false, data: action.payload, error: null },};
    case 'LOAD_THEMES_FAIL':
      return { ...state, themes: { ...state.themes, loading: false, error: action.payload },};

    case 'LOAD_CATEGORIES_REQUEST':
      return { ...state, categories: { ...state.categories, loading: true, error: null },};
    case 'LOAD_CATEGORIES_SUCCESS':
      return { ...state, categories: { ...state.categories, loading: false, data: action.payload, error: null },};
    case 'LOAD_CATEGORIES_FAIL':
      return { ...state, categories: { ...state.categories, loading: false, error: action.payload },};

    case 'PROCESS_CHANGED_CLEAR_STATE':
      return { ...initialState };

    default:
      return state;
  }
};
  
export default matrixReducer;
  